import React from "react";
import PolicyLayout from "./PolicyLayout";

function IntellectualProperty() {
  return (
    <PolicyLayout
      title="Intellectual property policy"
      intro="This policy covers the original brand presentation, catalogue photographs, product writing and interface material published on the mavormira storefront."
    >
      <section>
        <h2>Permitted customer use</h2>
        <p>You may view, temporarily cache, print or share a page link for personal shopping, order support or another use allowed by law. Buying a product transfers the physical item, not ownership of the site's photographs, layout, wordmark, product descriptions or other creative content.</p>
      </section>

      <section>
        <h2>Prohibited commercial reuse</h2>
        <p>Do not copy catalogue images into another store, remove rights information, present site text as another seller's work, train a competing product catalogue from the content, create a confusing brand identity, or use automated extraction that burdens the service. These restrictions do not prevent quotation, criticism, accessibility use or another exception protected by law.</p>
      </section>

      <section>
        <h2>Third-party rights in messages</h2>
        <p>Only send photographs or written material that you created, are authorised to provide, or may lawfully use for a support request. Supplying it for an investigation permits the limited internal use needed to understand and answer that request; it does not transfer the sender's ownership.</p>
      </section>

      <section>
        <h2>Reporting an infringement concern</h2>
        <p>Identify the exact site URL and content, describe the protected work or mark, explain the basis of the claim, and provide a reliable reply address. We will compare the notice with the source material and may ask for proportionate proof of authority before changing or removing content. A knowingly false notice may harm the rights of others.</p>
      </section>
    </PolicyLayout>
  );
}

export default IntellectualProperty;
